import React from "react";
// APIモジュール
import { Paper, Grid, Button, Typography } from "@material-ui/core";
import HelpButton from "./HelpButton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  field: {
    width: "100%",
    marginTop: theme.spacing(3),
    alignItems: "center",
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  interval: {
    marginTop: theme.spacing(5),
  },
  paper: {
    alignItems: "center",
    marginTop: theme.spacing(5),
    margin: theme.spacing(3),
    padding: theme.spacing(8),
  },
  priceText: {
    marginLeft: "10px",
  },
  image: {
    width: "100%",
  },
}));

export default function License(props) {
  const classes = useStyles();
  const profile = props.profile;
  const portalUrl = props.portalUrl;

  return (
    <React.Fragment>
      {portalUrl ? (
        <Paper className={classes.paper} elevation={3} variant="outlined">
          <Typography variant="h4" align="center" gutterBottom>
            {profile.name ? profile.name : "(名前未登録)"}
            さんの契約情報
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={1}>
              <HelpButton
                title={
                  <>
                    <Typography variant="caption" display="block">
                      現在の登録しているプランを見ることができます。
                      <br />
                      また、キャンセルや支払い方法の追加やシステムの解約、領収書のダウンロードもできます。
                    </Typography>
                    <Button
                      variant="contained"
                      target="_blank"
                      fullWidth
                      href="https://youtu.be/Z0IJPSWIPcw"
                    >
                      詳しくはこちら
                    </Button>
                  </>
                }
              />
            </Grid>
            <Grid item xs={11}>
              <Button
                variant="contained"
                fullWidth
                disabled={!portalUrl}
                href={portalUrl}
              >
                確認
              </Button>
            </Grid>
          </Grid>
        </Paper>
      ) : null}
    </React.Fragment>
  );
}
